import styled from 'styled-components';
import { CommonButton } from '../common/CommonButton';

export const WaringModal = ({
  visible = false,
  close,
}: {
  visible?: boolean;
  close?: () => void;
}) => {
  return (
    <ModalWrap $visible={visible}>
      <Dim />
      <ModalContent $visible={visible}>
        <Title>유의사항</Title>
        <Content>
          <ContentListItem>
            각 새틀라이트는 <Emphasize>시작 5분 전부터 입장</Emphasize> 가능합니다.
          </ContentListItem>
          <ContentListItem>
            새틀라이트는 입장 마감 전이라면 리엔트리를 할 수 있습니다.
          </ContentListItem>
          <ContentListItem>
            단 남은 최대 엔트리 수에 따라 엔트리가 불가능할 수 있습니다.
          </ContentListItem>
          <ContentListItem>
            <Emphasize>중도 포기 시 참가비는 환불되지 않습니다.</Emphasize>
          </ContentListItem>
          <ContentListItem>
            <Emphasize>인더머니를 달성하여 획득한 티켓은 티켓함으로 지급됩니다.</Emphasize>
          </ContentListItem>
          <ContentListItem>
            참가권은 메인/사이드 각각 동일 명의로 생성된 모든 계정을 포함해 1장씩만 획득 가능하고 이미 참가 티켓을 획득한 경우
            새틀라이트는 참가할 수 없습니다.
          </ContentListItem>
          <ContentListItem>
            준비한 <Emphasize>참가권이 모두 소진되면 새틀라이트 운영은 조기에 마감</Emphasize>됩니다.
          </ContentListItem>
          <ContentListItem>
            본 새틀라이트는 내부 사정에 따라 통보 없이 종료될 수 있으며{` `}
            <Emphasize>부적절한 방법으로 참여 시 운영자에 의해 제재</Emphasize>될 수 있습니다.
          </ContentListItem>
        </Content>
        <ButtonContainer onClick={close}>
          <CommonButton text="확인" />
        </ButtonContainer>
      </ModalContent>
    </ModalWrap>
  );
};

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;

  button {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  max-width: 90%;
  max-height: 80%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px;
  border-radius: 20px 20px 0px 0px;
  padding: 25px 15px 15px 15px;
`;

const Content = styled.ul`
  border-radius: 8px;
  background: #201f1e;
  padding: 20px 10px;
  list-style: none;
`;

const ContentListItem = styled.li`
  color: #b2b2b2;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.39px;
  margin-bottom: 10px;
  position: relative;
  padding-left: 15px;

  &:after {
    content: '';
    width: 5px;
    height: 5px;
    position: absolute;
    background-color: #b2b2b2;
    top: 5px;
    left: 0;
    border-radius: 50%;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.h3`
  color: #fbf6d5;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
`;

const Emphasize = styled.span`
  font-weight: bold;
`;
